import { MaestroVersions } from '@automata/api/apiSchemas';
import { Select } from '@automata/ui';
import { logger } from '@automata/utils';
import { useFlag } from '@automata/utils/hooks';
import MenuItem from '@mui/material/MenuItem';
import { ControllerRenderProps } from 'react-hook-form';

import { MaestroEditorContent } from 'components/MaestroEditor';
import { useSnackbar } from 'hooks/useSnackbar';

import { CustomVersionSelector } from './CustomVersionSelector';
import { getVersionCompatibleName } from './utils';

interface MaestroSelectorProps {
  field: ControllerRenderProps<
    MaestroEditorContent,
    `workflow.resource_versions.maestro`
  >;
  maestroVersionsData: MaestroVersions;
  setCompatibleDriversVersionFilter: (value: string) => void;
  disabled?: boolean;
}

export const MaestroSelector = ({
  field,
  maestroVersionsData,
  disabled = false,
  setCompatibleDriversVersionFilter,
}: MaestroSelectorProps): JSX.Element | null => {
  const allowCustomMaestroVersions = useFlag('fe.custom_maestro_version');
  const { enqueueSnackbar } = useSnackbar();

  if (maestroVersionsData.versions.length === 0) {
    const err = 'No scheduler engine versions available';
    logger.error(err);
    enqueueSnackbar(err, { variant: 'error' });
  }
  if (allowCustomMaestroVersions) {
    return (
      <CustomVersionSelector
        reactHookFormField={field}
        disabled={disabled}
        versions={maestroVersionsData.versions}
        setCompatibleDriversVersionFilter={setCompatibleDriversVersionFilter}
      />
    );
  }

  return (
    <Select
      {...field}
      disabled={disabled}
      label="Scheduler Engine version"
      sx={{ width: '11rem' }}
      MenuProps={{ sx: { height: '50vh' } }}
      error={!field.value}
      helperText={field.value ? '' : 'Required'}
    >
      {maestroVersionsData.versions.map((version) => (
        <MenuItem
          key={version.name}
          value={version.name}
          onClick={() => {
            setCompatibleDriversVersionFilter(version.drivers_version);
          }}
        >
          {getVersionCompatibleName(version)}
        </MenuItem>
      ))}
    </Select>
  );
};
